<template>
  <div id="header" :class="{ scrolled: isScrolled }">
    <div class="headerin">
      <div id="etw_logo">
        <router-link to="/" style="display:flex;align-items:center;gap:10px">
          <div class="logo-text">Paper<span>Stirrer</span></div>
          <img :src="require('@/assets/images/Header/header.png')" alt="PaperStirrer" style="height:30px">
        </router-link>
      </div>
      <button class="navbar-toggler" @click="toggleNav" aria-label="Toggle navigation">
        <span></span><span></span><span></span>
      </button>
      <nav class="top-nav" :class="{ active: navOpen }" id="topNav">
        <ul>
          <li class="nav-item" :class="{ active: $route.path === '/' }">
            <router-link to="/" class="nav-link" @click.native="closeNav">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="firstCategoryPath" class="nav-link" @click.native="closeNav">Products</router-link>
          </li>
          <li class="nav-item" :class="{ active: $route.path === '/about' }">
            <router-link to="/about" class="nav-link" @click.native="closeNav">About Us</router-link>
          </li>
          <li class="nav-item" :class="{ active: $route.path === '/videos' }">
            <router-link to="/videos" class="nav-link" @click.native="closeNav">Videos</router-link>
          </li>
          <li class="nav-item" :class="{ active: $route.path.startsWith('/news') }">
            <router-link to="/news" class="nav-link" @click.native="closeNav">News</router-link>
          </li>
          <li class="nav-item" :class="{ active: $route.path === '/contact' }">
            <router-link to="/contact" class="nav-link" @click.native="closeNav">Contact</router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { getCategories } from '@/api/category'

export default {
  name: 'AppHeader',
  data() {
    return {
      navOpen: false,
      isScrolled: false,
      categories: []
    }
  },
  computed: {
    firstCategoryPath() {
      if (this.categories.length > 0) {
        return '/products/' + this.categories[0].id
      }
      return '/products'
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.loadCategories()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleNav() {
      this.navOpen = !this.navOpen
    },
    closeNav() {
      if (window.innerWidth <= 991) {
        this.navOpen = false
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    async loadCategories() {
      try {
        const res = await getCategories()
        this.categories = Array.isArray(res) ? res : (res.data || [])
      } catch (e) {
        // Fallback static categories
        this.categories = [
          { id: 1, name: 'Paper Cutlery', slug: 'paper-cutlery' },
          { id: 2, name: 'Paper Straws', slug: 'paper-straws' },
          { id: 3, name: 'Paper Food Containers', slug: 'paper-food-containers' },
          { id: 4, name: 'Paper Cups', slug: 'paper-cups' }
        ]
      }
    }
  }
}
</script>
